import { AJOObject } from 'mp-js-react-auto-json-object';
import { Link } from 'react-router-dom';
import { AccordeonTable } from '../../component/AccordeonTable';
import { ContactView } from '../../component/ContactView';
import { PrestationList } from '../../component/PrestationList';
import { DoubleDateModal } from '../../modal/vendor/DoubleDateModal';
import { SelectPrestationListModal } from '../../modal/vendor/SelectPrestationListModal';
import Contact from '../../object/Contact';
import Prestation from '../../object/profile/Prestation';
import { Col } from '../table/Col';
import Table from '../table/Table';

export interface ContactColInterface {
    ContactColInterface: boolean;
    getContact(): Contact | null;
}

export class ContactCol<Type extends AJOObject> extends Col<Type> {
    constructor(table: Table<Type>, get: (elem: Type) => AJOObject = (elem) => elem, name: string = 'Contact') {
        super(name);
        this.table = table;
        this.render = (elem: Type) => {
            if ('ContactColInterface' in get(elem)) {
                let inter = get(elem) as unknown as ContactColInterface;
                let res;
                if (inter.getContact() != null) {
                    res = <ContactView canDelete={false} onDelete={() => {}} contact={inter.getContact()!} />;
                } else {
                    res = <div>Aucun contact</div>;
                }
                return res;
            } else {
                throw new Error('ContactColInterface not found in elem');
            }
        };
        const obj = this;
        this.renderFilterModal = () => {
            return <SelectPrestationListModal col={obj} />;
        };
        this.filter = (elem: Type) => {
            if ('ContactColInterface' in get(elem)) {
                let inter = get(elem) as unknown as ContactColInterface;
                return (
                    obj.filterList.length === 0 ||
                    obj.filterList.find(
                        (e: AJOObject) => e.getAjoIdentifier() === inter.getContact()?.getAjoIdentifier() ?? '',
                    ) !== undefined
                );
            } else {
                throw new Error('ContactColInterface not found in elem');
            }
        };
        this.sort = (a: Type, b: Type) => {
            if ('ContactColInterface' in get(a) && 'ContactColInterface' in get(b)) {
                let aInter = get(a) as unknown as ContactColInterface;
                let bInter = get(b) as unknown as ContactColInterface;
                return (aInter.getContact()?.name.get() ?? '').localeCompare(bInter.getContact()?.name.get() ?? '');
            } else {
                throw new Error('ContactColInterface not found in a or b');
            }
        };
        this.typeRender = 'info';
        this.type = 'sort';
        this.senseSort = 0;
    }
}
